import { render, staticRenderFns } from "./VueGoogleAutocomplete.vue?vue&type=template&id=53422fc4"
import script from "./VueGoogleAutocomplete.vue?vue&type=script&lang=js"
export * from "./VueGoogleAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports